import { usePhoneNumberFormatter } from "@/ContactDirectory/Hooks/usePhoneNumberFormatter";
import { DirectoryFaxNumber } from "@/ContactDirectory/Models/DirectoryFaxNumber";

import styles from "./EstablishmentFaxNumbersList.module.scss";

interface IEstablishmentFaxNumbersListProps {
    faxNumbers: DirectoryFaxNumber[];
    entityId: string;
    onSelectFaxNumber: (faxNumberId: string) => void;
}

function FaxNumberFormatter(fax: DirectoryFaxNumber): string {
    const formatter = usePhoneNumberFormatter(fax.countryId);
    return formatter(fax);
}

export function EstablishmentFaxNumbersList(props: IEstablishmentFaxNumbersListProps): JSX.Element {
    if (!props.faxNumbers.any())
        return null;

    return (
        <div className={`${styles.container}`}>
            {props.faxNumbers.map(faxNumber => (
                <div
                    key={`${props.entityId}-${faxNumber.id}`}
                    className={styles.list}
                    title={`F: ${FaxNumberFormatter(faxNumber)}${faxNumber.description ? ` ${faxNumber.description}` : ""}`}
                    onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onSelectFaxNumber(faxNumber.id);
                    }}
                >
                    <div className={styles.faxNumber}>{`F: ${FaxNumberFormatter(faxNumber)}`}</div>
                    <div className={`${styles.description}`}>{faxNumber.description}</div>
                </div>
            ))}
        </div>
    );
}
